import { render } from "./SupplierPaymentReport.vue?vue&type=template&id=5868c728&scoped=true"
import script from "./SupplierPaymentReport.vue?vue&type=script&lang=js"
export * from "./SupplierPaymentReport.vue?vue&type=script&lang=js"

import "../inventory/inventoryReport.css?vue&type=style&index=0&id=5868c728&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5868c728"]])

export default __exports__